import React from 'react';

const SliderWidget = ({ settings, value, onChange }) => {
  const min = settings?.min || 0;
  const max = settings?.max || 100;
  const step = settings?.step || 1;
  const defaultVal = settings?.default ?? min;
  const displayValue = value || String(defaultVal);

  // Initialize with default on first render
  React.useEffect(() => {
    if (!value) onChange(String(defaultVal));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  };

  const sliderStyle = {
    flex: 1,
    height: '6px',
    cursor: 'pointer',
  };

  const valueStyle = {
    minWidth: '40px',
    textAlign: 'right',
    fontSize: '0.9rem',
    fontWeight: 500,
  };

  return (
    <div style={containerStyle}>
      <span style={{ fontSize: '0.8rem', color: '#888' }}>{min}</span>
      <input
        type="range"
        value={displayValue}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        max={max}
        step={step}
        style={sliderStyle}
      />
      <span style={{ fontSize: '0.8rem', color: '#888' }}>{max}</span>
      <span style={valueStyle}>{displayValue}</span>
    </div>
  );
};

export default SliderWidget;
